import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import BaseUrl from '../../base-api';
import "./ApplicationStatus.css";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import moment from 'moment/moment';
import jsPDF from 'jspdf';
import { submitPaymentForm } from "../../Utils/Commons";
import logo from "./../../assets/logo.jpg";
import hkcl from "../../assets/hkcl.png";
import imageCompression from 'browser-image-compression';
import spinner from './../../assets/images/Spinner.gif';
import 'jspdf-autotable';

const ApplicationStatus = () => {
    const [applications, setApplications] = useState([]);
    const [statusType, setStatusType] = useState('');
    const [title, setTitle] = useState('');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize] = useState(10);
    const location = useLocation();
    useEffect(() => {
        const { status, title } = location.state || {};
        if (status) {
            setStatusType(status);
            setTitle(title);
            console.log("title" + title)
        } else {
            console.warn('Status not found in location state, using default status.');
        }
    }, [location.state]);

    useEffect(() => {
        const fetchApplications = async () => {
            if (!statusType) {
                return;
            }

            try {
                setLoading(true);
                const response = await axios.get(`${BaseUrl}/admin/fetchApplicationstatus`, {
                    headers: {
                        Authorization: localStorage.getItem("$3ingT0k3n"),
                    },
                    params: {
                        statusType: statusType,
                        page: currentPage,
                        size: pageSize,
                    },
                });


                setApplications(response.data.content);
                setTotalPages(response.data.totalPages);
            } catch (error) {
                setError('Failed to fetch data');
            } finally {
                setLoading(false);
            }
        };

        fetchApplications();
    }, [statusType, currentPage, pageSize]);

    const handlePageChange = (direction) => {
        setCurrentPage(prevPage => {
            if (direction === 'next' && prevPage < totalPages - 1) {
                return prevPage + 1;
            } else if (direction === 'prev' && prevPage > 0) {
                return prevPage - 1;
            }
            return prevPage;
        });
    };

    const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    if (loading) return <div className="col-xl-12 col-xxl-12 col-sm-12">
        <div className="card me-2">
            <div className="card-header text-center">
                <img src={spinner} alt='Loading...' width={150} />

                <p>Please wait ....</p></div>
        </div>
    </div>;
    if (error) return <p>{error}</p>;

    const exportData = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Registered Candidates');

        // Define worksheet columns
        worksheet.columns = [
            { header: 'Candidate Name', key: 'candidateName' },
            { header: 'Father Name', key: 'fatherName' },
            { header: 'Date of Birth', key: 'dob' },
            { header: 'Mobile Number', key: 'mobileNumber' },
            { header: 'Email', key: 'email' },
            { header: 'Address', key: 'address' },
            { header: 'Course', key: 'course' },
            { header: 'Enrolled Date', key: 'enrolled' },
            { header: 'Fee Paid', key: 'feePaid' },
            { header: 'Photograph', key: 'photo' },
            { header: 'Signature', key: 'sign' },
            { header: '12th Document', key: '12th' },
            { header: 'University Document (if any)', key: 'uni' },


        ];

        // Loop through each data entry
        for (const t of applications) {
            // Add a row with data
            const row = worksheet.addRow({
                candidateName: t.applicantName,
                fatherName: t.fatherName,
                dob: t.dob,
                mobileNumber: t.mobileNumber,
                email: t.email,
                address: t.address,
                course: t.course,
                enrolled: t.enrolledOn,
                feePaid: t.status === 'COURSE_FEE_PAID' ? 'Yes' : 'No',


            });

            // Starting column index for images
            let nextImageCol = 6;
            // Loop through each document and add images
            for (const [docIndex, doc] of t.documents.entries()) {
                try {
                    // Convert base64 string to buffer
                    const imageBuffer = Buffer.from(doc.data, 'base64');

                    // Determine the image extension
                    const mimeType = getMimeTypeFromByteArray(imageBuffer);
                    const extension = mimeType === 'image/jpeg' ? 'jpeg' : 'png';

                    // Add image to the workbook
                    const imageId = workbook.addImage({
                        buffer: imageBuffer,
                        extension: extension,
                    });

                    // Add the image to the specific cell
                    worksheet.addImage(imageId, {
                        tl: { col: nextImageCol, row: row.number - 1 }, // Top-left corner of the cell
                        ext: { width: 100, height: 100 } // Dimensions of the image
                    });

                    // Move to the next column for the next image
                    nextImageCol++;
                } catch (error) {
                    console.error("Error adding image:", error);
                }
            }
        }

        try {
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, 'CourseFeePaid.xlsx');
        } catch (error) {
            console.error("Error writing Excel file:", error);
        }
    };
    const getMimeTypeFromByteArray = (buffer) => {
        const arr = new Uint8Array(buffer).subarray(0, 4);
        let header = "";
        for (let i = 0; i < arr.length; i++) {
            header += arr[i].toString(16);
        }

        switch (header) {
            case "89504e47":
                return "image/png";
            case "ffd8ffe0":
            case "ffd8ffe1":
            case "ffd8ffe2":
            case "ffd8ffe3":
            case "ffd8ffe8":
                return "image/jpeg";
            default:
                return "application/octet-stream";
        }
    };
    const compressImage = async (base64Image) => {
        const response = await fetch(base64Image);
        const blob = await response.blob();
        const options = {
            maxSizeMB: 2,
            maxWidthOrHeight: 1200,
            useWebWorker: true,
        };
        try {
            const compressedBlob = await imageCompression(blob, options);
            const compressedBase64 = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(compressedBlob);
                reader.onloadend = () => resolve(reader.result);
            });

            return compressedBase64;
        } catch (error) {
            console.error("Error during image compression", error);
            return base64Image;
        }
    };
    const downloadDetails = async (course) => {
        try {
            let photo = null;
            let sign = null;
            for (const data of course.documents) {
                if (data.data) {
                    const base64Image = 'data:image/jpeg;base64,' + data.data;
                    const compressedImageBase64 = await compressImage(base64Image);
                    switch (data.docName) {
                        case "photo":
                            photo = compressedImageBase64;
                            break;
                        case "sign":
                            sign = compressedImageBase64;
                            break;
                        default:
                            break;
                    }
                }
            }
            const doc = new jsPDF();
            const pageWidth = doc.internal.pageSize.getWidth();
            const currentTime = new Date().toLocaleString();

            const websiteName = "Guru Jambheshwar University of Science & Technology, Hisar";
            const websiteNameWork = "Admission Form";

            const imageWidth = 20;
            const imageHeight = 20;
            const imageX = 10;

            doc.setFont("helvetica");

            const addHeader = () => {
                doc.setFontSize(8).setTextColor("black");
                const generatedTextWidth = doc.getTextWidth(`Generated on: ${currentTime}`);
                const generatedX = pageWidth - generatedTextWidth - 10;
                doc.text(`Generated on: ${currentTime}`, generatedX, 10);
                doc.text("https://gjuskillcourses.hkcl.in", 10, 10);

            };

            doc.setFontSize(16).setFont("helvetica", "bold");
            addHeader();
            doc.addImage(logo, 'JPEG', imageX, 12, imageWidth, imageHeight);

            doc.setFontSize(12).setTextColor("green");

            doc.text(websiteName, imageX + imageWidth + 12, 20);
            doc.text(websiteNameWork, (pageWidth / 2) - imageX - imageWidth + 15, 30);
            doc.addImage(hkcl, 'JPEG', pageWidth - imageX - imageWidth - 5, 14, imageWidth + 5, imageHeight);

            doc.setFontSize(12).setTextColor("black");
            doc.text("Enrolled Course: " + course.course, 15, 40);
            doc.setFontSize(12).setTextColor("green");

            // doc.addImage(photo, 'JPEG', pageWidth-60,imageHeight+20, 40, 40);
            doc.text("Personal Details", 15, 50);
            doc.autoTable({
                startY: 55,
                columnStyles: {
                    0: { cellWidth: 40 },
                    1: { cellWidth: 100 },
                },
                body: [
                    [
                        { content: "Candidate Name", styles: { fontStyle: 'bold' } },
                        course.applicantName
                    ],
                    [
                        { content: "Father Name", styles: { fontStyle: 'bold' } },
                        course.fatherName
                    ],
                    [
                        { content: "Mobile Number", styles: { fontStyle: 'bold' } },
                        course.mobileNumber
                    ],
                    [
                        { content: "Email", styles: { fontStyle: 'bold' } },
                        course.email
                    ],
                    [
                        { content: "Date of Birth", styles: { fontStyle: 'bold' } },
                        moment(course.dob).format("DD/MM/YYYY")
                    ]
                ],
                theme: 'grid',
                styles: {
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0],
                },
                didDrawPage: (data) => {
                    if (data.pageNumber > 1) {
                        addHeader();
                    }
                    const x = data.settings.margin.left + 5;
                    const y = 55;

                    doc.addImage(photo, 'JPEG', 160, y, 37, 38);
                }

            });

            doc.setFontSize(12).setTextColor("green");
            doc.text("Details of 12th Standard or Equivalent", 15, doc.autoTable.previous.finalY + 10);
            doc.setFontSize(16);
            doc.autoTable({
                startY: doc.autoTable.previous.finalY + 15,
                body: [[{ content: "Roll Number", styles: { fontStyle: 'bold' } }, course.rollNumber],
                [{ content: "Board", styles: { fontStyle: 'bold' } }, course.board],
                [{ content: "Passing Month-Year", styles: { fontStyle: 'bold' } }, course.passingYear],
                [{ content: "Marks Obtained", styles: { fontStyle: 'bold' } }, course.marks],
                ],
                theme: 'grid',
                styles: {
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0]
                },
                didDrawPage: (data) => {
                    if (data.pageNumber > 1) {
                        addHeader();
                    }
                }
            });
            doc.setFontSize(12).setTextColor("green");
            doc.text("Address Details", 15, doc.autoTable.previous.finalY + 10);
            doc.autoTable({
                startY: doc.autoTable.previous.finalY + 15,
                body: [[{ content: "Address", styles: { fontStyle: 'bold' } }, course.address],
                [{ content: "District", styles: { fontStyle: 'bold' } }, course.district],
                [{ content: "State", styles: { fontStyle: 'bold' } }, course.state],
                [{ content: "Country", styles: { fontStyle: 'bold' } }, course.country],
                [{ content: "Pincode", styles: { fontStyle: 'bold' } }, course.pinCode],
                    // ["Are you the GJU University Employee/ Ward/ Spouse ?", course.employee]];
                ],
                theme: 'grid',
                styles: {
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0]
                },
                didDrawPage: (data) => {
                    if (data.pageNumber > 1) {
                        addHeader();
                    }
                }
            });
            doc.text("Submitted Documents", 15, doc.autoTable.previous.finalY + 10);
            doc.autoTable({
                startY: doc.autoTable.previous.finalY + 15,
                head: [['Sr. No.', 'Name']],
                body: course.documents.map((item, index) => [index + 1, item.docName]),
                theme: 'grid',
                styles: {
                    lineWidth: 0.1,
                    lineColor: [0, 0, 0],
                    halign: 'center'
                },
                columnStyles: {
                    0: { cellWidth: 40 }
                },
                didDrawPage: (data) => {
                    // Add header on new pages
                    if (data.pageNumber > 1) {
                        addHeader();
                    }
                }
            });
            doc.setFontSize(8).setFont("helvetica", "underline").setTextColor("black");
            doc.addImage(sign, 'JPEG', pageWidth - 50, doc.autoTable.previous.finalY + 10, 35, 10);
            doc.text("(Applicant Signature)", pageWidth - 40, doc.autoTable.previous.finalY + 25);
            doc.save('Admission Form.pdf');
        } catch (error) {
            console.error('Failed to generate PDF:', error);
            alert('Failed to generate PDF. Please try again.');
        }
    };
    return (
        <div className="table-container">
            <h2>{title} {statusType == 'CourseFeePaid' && <a href="" onClick={(e) => {
                e.preventDefault(); exportData();
            }} style={{
                float: 'right',
                fontSize: '1.2rem'
            }}>Export</a>}</h2>
            <table>
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>Learner Name</th>
                        <th>Candidate Code</th>
                        <th>Mobile Number</th>
                        <th>Date of Birth</th>
                        <th>Enrolled Course</th>
                        <th>Is GJU Employee?</th>
                        <th>Registration Date</th>
                        {statusType == 'CourseFeePaid' && <th>Admission Form</th>}

                    </tr>
                </thead>
                <tbody>
                    {applications.map((app, index) => (
                        <tr key={index}>
                            <td>{index + 1 + (currentPage * pageSize)}</td>
                            <td>{app.applicantName}<br /><b>S/D/o</b> {app.fatherName}</td>
                            <td>{app.candidateCode}</td>
                            <td>{app.mobileNumber}</td>
                            <td>{moment(app.dob).format('DD/MM/YYYY')}</td>
                            <td>{app.course}</td>
                            <td>{app.employee ? "Yes" : "No"}</td>
                            <td>{app.enrolledOn}</td>
                            {statusType == 'CourseFeePaid' && <td>

                                <a style={{ color: "blue" }} href="" onClick={(e) => { e.preventDefault(); downloadDetails(app); }}>Print</a>
                            </td>}
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination-controls">
                <button
                    onClick={() => handlePageChange('prev')}
                    disabled={currentPage === 0}
                >
                    Previous
                </button>
                <span>Page {currentPage + 1} of {totalPages}</span>
                <button
                    onClick={() => handlePageChange('next')}
                    disabled={currentPage >= totalPages - 1}
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default ApplicationStatus;
